import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    // paddingBottom: '3.2rem',
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
}))

export const ContentContainer = styled('div', ({ $theme }) => ({
    margin: '2.4rem 1.6rem 0'
}))

export const InnerContainer = styled('div', ({ $theme }) => ({
    flex: 1
}))

export const Line = styled<'div', { $big?: boolean; $bigMargin?: boolean }>('div', ({ $theme, $big }) => ({
    height: $big ? '4px' : '1px',
    width: '100%',
    backgroundColor: $big ? '#F7F7FF' : '#F7F7FF',
    margin: '2.4rem 0'
}))

export const TitleContainer = styled('div', ({ $theme }) => ({
    textAlign: 'center',
    padding: '2.2rem 0',
    position: 'relative'
}))

export const AccordionContainer = styled<'div', { $opened?: boolean }>('div', ({ $theme, $opened = false }) => ({
    margin: '2rem 2rem 0',
    borderTop: '1px solid #EAECF0',
    ...(!$opened && {
        borderBottom: '1px solid #EAECF0'
    })
}))

export const AccordionContent = styled('div', ({ $theme }) => ({
    padding: '0rem 1.6rem 2rem'
}))

export const StickySection = styled<'div', { $hide?: boolean }>('div', ({ $theme, $hide = false }) => ({
    height: '100%',
    display: 'flex',
    border: '1px solid #CCCCCC',
    padding: '2.4rem 1.6rem',
    justifyContent: 'space-between',
    backgroundColor: '#fff',

    ...($hide && {
        display: 'none'
    }),

    [$theme.mediaQuery.large]: {
        border: 'none'
    }
}))

export const ErrorContainer = styled('div', ({ $theme }) => ({
    padding: '2rem',
    backgroundColor: '#FEF3F2',
    color: '#667085'
}))
